import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getUsersOfUserGroup } from "../../../../services/usersService";
import withGlobalData from "../../common/withGlobalData";
class SearchUserUserGroup extends Component {
  state = {
    reload: this.props.globalData.reload,
    open: false,
    users: [],
    user: {},
  };

  componentDidMount() {
    this.getUsers();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getUsers();
      this.setState({ reload: globalData.reload });
    }
  }

  async getUsers() {
    const groupID = this.props.groupID;
    const response = await getUsersOfUserGroup(groupID);
    const { data: users } = response;
    this.setState({ open: false, users });
  }

  render() {
    const { users } = this.state;
    const { onSelectUser } = this.props;
    return (
      <CustomDataTableSearch
        data={users}
        onRefreshData={() => {
          this.getUsers();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectUser(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectUser(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "User ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "First Name",
            field: "firstName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.firstName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Last Name",
            field: "lastName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.lastName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "UserName",
            field: "username",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.username} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "User Group",
            field: "userGroup.groupName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis
                  text={rowData.userGroup.groupName}
                  maxLine="1"
                />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Authorization",
            field: "authorization.authName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis
                  text={rowData.authorization.authName}
                  maxLine="1"
                />
              </React.Fragment>
            ),
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchUserUserGroup);
